import { isTypeCtaSection } from '@platform/contentful';
import { Entry } from 'contentful';
import Divider from './util/Divider';
import { Button, ButtonVariants } from '@platform/components';

const ContentfulCtaSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeCtaSection(entry)) {
    return null;
  }

  let buttonVariant: ButtonVariants = 'primary';

  // TODO: These are weird; 'Green' buttons are actually not rendered as Green on prod. Need
  // to re-eval which ones need supported after we clean up old Contentful pages
  if (entry.fields.mainCta?.fields.type === 'Green') {
    buttonVariant = 'secondary-color';
  }

  return (
    <div className='flex flex-col text-center items-center max-w-[800px] mx-auto mt-8 mb-12 sm:mt-16 sm:mb-24'>
      <h1 className='my-3 text-4xl sm:text-5xl font-sans font-bold text-gray-500'>
        {entry.fields.header}
      </h1>
      <p className='text-xl sm:text-2xl font-light'>{entry.fields.subHeader}</p>
      <Divider />
      {entry.fields.mainCta && (
        <div className='mt-6'>
          <Button
            variant={buttonVariant}
            size='2xl'
            href={entry.fields.mainCta.fields.url}
            target={entry.fields.mainCta.fields.openInNewTab ? '_blank' : undefined}
            rel={entry.fields.mainCta.fields.openInNewTab ? 'noreferrer' : undefined}
          >
            {entry.fields.mainCta.fields.text}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ContentfulCtaSection;
